import { render } from "./TrainingDashboardView.vue?vue&type=template&id=3a4f3fe8&scoped=true"
import script from "./TrainingDashboardView.vue?vue&type=script&lang=js"
export * from "./TrainingDashboardView.vue?vue&type=script&lang=js"

import "./TrainingDashboardView.vue?vue&type=style&index=0&id=3a4f3fe8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a4f3fe8"]])

export default __exports__